import { getJsonPathValue } from '@carboncopyco/editor-utils';
import type { JsonFormValue } from './types';

export const shouldTakeUpRemainingSpace = (fields: JsonFormValue['fields']) => {
  // If the last field is a table, it should take up the remaining space.
  return fields[fields.length - 1]?.uiSchema.type === 'table';
};

export const getFieldValue = (
  json: JsonFormValue['json'],
  jsonPath: string
) => {
  try {
    return getJsonPathValue(json, jsonPath);
  } catch (error) {
    console.log(error);
    return null;
  }
};
